import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { UserStoreService } from 'src/app/core/services/user-store.service';
import { User } from '@data/schema/user-state';
import { MenuItem } from '@data/schema/menuitem';
import { DynamicBreadcrumbService } from '@shared/services/dynamic-breadcrumb.service';
import { LocalStorageService } from '@gah-core/services/local-storage.service';
import { UserGroupTerritory } from '@data/schema/user-group-territory';
import { Router } from '@angular/router';
import { UserRoles } from '@data/schema/user-roles';
import { AppUtilService } from '@gah-core/services/app-util.service';
import { defaultAppLanguage } from '@gah-core/constants/common-constants';
import { appLanguages } from '@gah-core/utils/app-languages';
import { NgxSpinnerService } from 'ngx-spinner';
import { DigitalCartService } from '@modules/assets/services/digital-cart.service';
import { AddToCartRequest } from '@modules/assets/models/add-to-cart.model';
import { RolePriviliges } from '@data/schema/role-privileges';
import { ManageHomepageService } from '@modules/admin/manage-homepage/services/manage-homepage.service';
import { GlobalSearchService } from '@gah-core/services/global-search.service';
import { SessionStorageService } from '@gah-core/services/session-storage.service';
import { GahMatDialogComponent } from '../gah-mat-dialog/gah-mat-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { GoogleAnalyticsService } from '@shared/services/googleanalytics.service';
import { first } from 'rxjs/internal/operators/first';
import { GoogleanalyticsmoduleserviceService } from '@shared/services/googleanalyticsmoduleservice.service';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() public Url: Array<any> = [];
  logoPath1: string = 'assets/img/sony_logo_white.svg';
  logoPath2: string = 'assets/img/logo.svg';
  searchValue: string = '';
  isAuthenticated: boolean = false;
  menuItems: MenuItem[] = [];
  userStoreSub: Subscription;
  getMenuItemsSub: Subscription;
  menuItemsSub: Subscription;
  userRolesSub: Subscription;
  userRoles: UserRoles[];
  currentMenuItem: any;
  currentUser: User;
  currentRoute: any;
  userRolePrivileges: RolePriviliges[] = [];
  userPrivileges: string[] = [];
  cartItemsSub: Subscription;
  removedCartItemsSub: Subscription;
  isRemovedFromCart: boolean = false;
  itemList: { fileName: string; thumbnailUrl: string; runnerAssetReleaseId: number }[] = [];
  addtoCartReq: AddToCartRequest = new AddToCartRequest();

  usersGroupsTerritoriesSub: Subscription;
  usersGroupsTerritories: UserGroupTerritory[] = [];
  territoryExhibitor: {
    territoryId: number;
    territoryName: string;
    groupTypeCode: string;
    defaultLanguageCode: string;
  }[] = [];
  territoryPublicity: {
    territoryId: number;
    territoryName: string;
    groupTypeCode: string;
    defaultLanguageCode: string;
  }[] = [];
  selectedTerritory: string;
  selectedRole: string;
  selectedUserGroupTerritory: string;
  territoryDropdownInd: boolean = false;
  requestRoleCode: string;
  userPreferencesDetails: { parameterName: string; parameterValues: string }[] = [];
  userMenuMap: [];
  userMenuMapSub: Subscription;
  appLanguages = appLanguages;
  itemCounts: number = 0;
  showCartPopover: boolean = false;
  hasReleaseSchedulePrivilege: boolean = false;
  isReleaseScheduleAvailable: boolean = false;
  releaseScheduleSub: Subscription;
  usersPreferredLanguage: string;
  menuLoading: boolean = false;
  territoryVr: {
    territoryId: number;
    territoryName: string;
    groupTypeCode: string;
    defaultLanguageCode: string;
  }[] = []; //GAHR1218

  private browserGlobals = {
    windowRef(): any {
      return window;
    },
    documentRef(): any {
      return document;
    },
  };
  constructor(
    public translate: TranslateService,
    public authService: AuthenticationService,
    private userStoreService: UserStoreService,
    private localStorageService: LocalStorageService,
    private sessionStorageService: SessionStorageService,
    private digitalCartService: DigitalCartService,
    private router: Router,
    private dynamicBreadcrumbService: DynamicBreadcrumbService,
    private utilService: AppUtilService,
    private spinner: NgxSpinnerService,
    private manageHomePageService: ManageHomepageService,
    private globalSearchService: GlobalSearchService,
    private dialog: MatDialog,
    private homepageService: ManageHomepageService,
    public googleanalyticsmoduleserviceService: GoogleanalyticsmoduleserviceService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Setting translation related configs.
    this.translate.addLangs(this.utilService.getAllLanguageCodes());
    this.translate.setDefaultLang(defaultAppLanguage);
    const savedLang = this.localStorageService.get('LANG') ?? this.translate.currentLang;
    this.translate.use(
      savedLang.match(this.utilService.getRegularExpForLangCodes())
        ? savedLang
        : this.translate.defaultLang
    );
    this.translate.onLangChange.subscribe((language) => {
      this.localStorageService.set('LANG', language.lang);
      this.changeLanguage(language.lang);
    });

    this.releaseScheduleSub = this.homepageService
      .getReleaseScheduleObservable()
      .subscribe((res) => {
        this.isReleaseScheduleAvailable = res;
        this.cdr.detectChanges();
      });
    this.userStoreSub = this.userStoreService.userState$.subscribe((user) => {
      this.currentUser = user;
      // Setting users preferred language
      this.usersPreferredLanguage = this.currentUser?.userPreferences?.userPreferenceDetails?.find(
        (i) => i.parameterName === 'language'
      ).parameterValues;
      if (
        this.usersPreferredLanguage !== null &&
        this.usersPreferredLanguage !== undefined &&
        this.translate.currentLang !== this.usersPreferredLanguage
      ) {
        this.translate.use(this.usersPreferredLanguage);
      }
      // Setting territory dropdown button label values
      this.selectedTerritory = this.currentUser?.userPreferences?.userPreferenceDetails?.find(
        (i) => i.parameterName === 'territoryName'
      ).parameterValues; 
      if (this.currentUser?.selectedTerritory?.groupTypeCode === 'E')
        this.selectedRole = '[Exhibitor Relations]';
      else if (this.currentUser?.selectedTerritory?.groupTypeCode === 'P')
        this.selectedRole = '[Publicity]';
      else if (this.currentUser?.selectedTerritory?.groupTypeCode === 'VR')
        this.selectedRole = '[Virtual Reality]';
      this.selectedUserGroupTerritory = this.selectedRole + ' ' + this.selectedTerritory;
      if (
        this.currentUser !== null &&
        this.currentUser !== undefined &&
        this.currentUser.userPrivileges !== undefined
      ) {
        this.hasReleaseSchedulePrivilege = this.currentUser?.userPrivileges[
          this.currentUser?.groupRolesId
        ]?.some(function (grp) {
          return grp.privilegeName === 'Upload/Download Release Schedule';
        });
        this.cdr.detectChanges();
      }
    });

    // Gets the updated userRolePrivileges
    this.authService.userRolePrivileges$.subscribe((res) => {
      this.userRolePrivileges = res;
      if (this.userRolePrivileges?.length !== 0 || this.userRolePrivileges !== null) {
        this.userPrivileges = [];
        this.userRolePrivileges?.forEach((element) => {
          this.userPrivileges.push(element.privilegeName);
        });
      } else {
        this.userPrivileges = [];
      }
    });

    // Load cart items when user is authenticated
    if (this.currentUser?.isAuthenticated && this.currentUser?.isLegalAccepted) {
      console.log('Loading cart items for authenticated user');
      this.loadCartItems();
    }

    // If user authenticated, makes request to get menu items and territories for group roles.
    if (this.currentUser?.isAuthenticated) this.menuLoading = true;
    if (this.currentUser?.isAuthenticated && this.localStorageService.get('T_EA')) {
      this.getMenuItemsSub = this.authService.getUserCurrentDetails().subscribe((_res) => { });
    }
    // Adds user specific menu items to the array.
    this.menuItemsSub = this.authService.menuItems$.subscribe((res) => {
      if (!this.localStorageService.get('currentMenuItem') && res.length > 0) {
        for (let element of res) {
          if (element.id === 'home') {
            this.localStorageService.set('currentMenuItem', element);
            break;
          }
        }
      }
      this.menuItems = res;
    });

    this.userMenuMapSub = this.authService.menuMap$.subscribe((res) => {
      this.userMenuMap = res;
      if (this.currentUser) {
        let requestRoleCd;
        for (let u of this.currentUser.userRoles) {
          if (this.currentUser?.groupTypeCode === u['roles']['groupTypeCode'] && u['roles']['activeInd'] == 1
            && this.currentUser.selectedTerritory?.territoryId == u['roles']['territoryId']) {
            requestRoleCd = u['roles']['requestRoleCode'];
            break;
          }
        }
        let key = this.currentUser?.groupTypeCode + requestRoleCd;
        this.menuItems = this.userMenuMap[key];
        this.menuLoading = false;
      }
    });
    // Fetch the user Roles for the user logged in
    this.userRolesSub = this.authService.userRolesItems$.subscribe((res) => {
      this.userRoles = res;
    });

    // Fetching group roles for the territory dropdown
    this.usersGroupsTerritoriesSub = this.authService.userGroupsTerritoryItems$.subscribe((res) => {
      this.usersGroupsTerritories = res;
      this.territoryDropdownInd = false;
      // Hiding dropdown if user only has one territory assigned to them
      if (res.length > 1) {
        this.territoryDropdownInd = true;
      }
      this.territoryExhibitor = [];
      this.territoryPublicity = [];
      this.territoryVr = [];

      for (const iterator of res) {
        if (iterator['groupTypeCode'] === 'E') {
          this.selectedRole = '[Exhibitor Relations]';
          this.territoryExhibitor.push({
            territoryId: iterator['territory']['territoryId'],
            territoryName: iterator['territory']['territoryName'],
            groupTypeCode: iterator['groupTypeCode'],
            defaultLanguageCode: iterator['territory']['defaultLanguageCode'],
          });
        } else if (iterator['groupTypeCode'] === 'P') {
          this.selectedRole = '[Publicity]';
          this.territoryPublicity.push({
            territoryId: iterator['territory']['territoryId'],
            territoryName: iterator['territory']['territoryName'],
            groupTypeCode: iterator['groupTypeCode'],
            defaultLanguageCode: iterator['territory']['defaultLanguageCode'],
          });
        }
        else if (iterator['groupTypeCode'] === 'VR') {
          this.selectedRole = '[Virtual Reality]';
          this.territoryVr.push({
            territoryId: iterator['territory']['territoryId'],
            territoryName: iterator['territory']['territoryName'],
            groupTypeCode: iterator['groupTypeCode'],
            defaultLanguageCode: iterator['territory']['defaultLanguageCode'],
          });
        }
      }
    });

    this.cartItemsSub = this.digitalCartService.cartItems$.subscribe((res) => {
      this.itemList = res;
      this.itemCounts = this.itemList.length;
      this.cdr.detectChanges();
    });

    this.removedCartItemsSub = this.digitalCartService.removeCartItems$.subscribe((res) => {
      this.isRemovedFromCart = res;
      this.cdr.detectChanges();
    });
  }
  
  /**
   * Load cart items from backend
   */
  loadCartItems(): void {
    this.digitalCartService.getCartItems().subscribe(
      (response) => {
        this.itemList = response.serviceResult || [];
        this.itemCounts = this.itemList.length;
        this.digitalCartService.updateCartItems(this.itemList);
        this.cdr.detectChanges();
      },
      (error) => {
        console.error('Error loading cart items:', error);
        this.itemList = [];
        this.itemCounts = 0;
        this.cdr.detectChanges();
      }
    );
  }

  toggleDigitalCart(_event: Event) {
    this.showCartPopover = !this.showCartPopover;
  }

  onClickRemoveFromCart(runnerAssetReleaseId) {
    this.spinner.show(runnerAssetReleaseId.toString());
    this.addtoCartReq.userId = this.userStoreService.userState.userId;
    this.addtoCartReq.runnerAssetReleaseId = runnerAssetReleaseId;
    this.digitalCartService.removeItemsFromCart(this.addtoCartReq).subscribe(
      (_res) => {
        this.spinner.hide();
        this.digitalCartService.getCartItems().subscribe((response) => {
          this.itemList = response.serviceResult;
          this.itemCounts = this.itemList.length;
          this.digitalCartService.updateCartItems(this.itemList);
          this.digitalCartService.updateRemovedCartItems(runnerAssetReleaseId);
          if (this.router.url === '/user/cart-checkout') {
            this.router.navigateByUrl('/').then(() => {
              this.router.navigateByUrl('/user/cart-checkout');
            });
          }
        });
      },
      (_err) => {
        this.spinner.hide(runnerAssetReleaseId.toString());
      }
    );
  }

  /**
   * Returns redirection url for menu items
   * @param menu object of menu item.
   * @returns url for redirection
   */
  getRouteUrl(menu: MenuItem): string {
    switch (menu.id) {
      case 'home':
        return '/';
      case 'titles':
        return '/admin/titles/manage-titles';
      case 'theaters':
        return 'admin/theaters';
      case 'group_sales':
        return menu.link;
      case 'group_sales_req':
        return menu.link;
      case 'screening':
        return menu.link;
      case 'users':
        return '/admin/users/manage-user';
      case 'my_account':
        return 'user/my-account';
      case 'homepage':
        return '/admin/manage-homepage/general-setting';
      case 'asset_category':
        return '/admin/asset-category-mapping';
      case 'email':
        return '/admin/campaign/emails';
      case 'restricted_access_request':
        return 'admin/manage-title-assets/manage-restricted-access';
      case 'looker_studio':
        return 'admin/lookerstudioreporting';

      default:
        return '';
    }
  }

  getMenuItem(menu: MenuItem) {
    if (menu.id === 'user_guides') {
      this.manageHomePageService
        .getUserGuideFile(this.currentUser?.groupsTerritoryId, 'UG')
        .subscribe((res) => {
          const fileURL = URL.createObjectURL(res);
          window.open(fileURL, '_blank');
        });
    }
    this.localStorageService.set('currentMenuItem', menu);
    this.globalSearchService.setSearchValue(null);
    //Google Analytics
  }

  onRightClick(territory: {
    territoryId: number;
    territoryName: string;
    groupTypeCode: string;
    defaultLanguageCode: string;
  }) {
    for (const iterator of this.currentUser['userPreferences']['userPreferenceDetails']) {
      switch (iterator['parameterName']) {
        case 'territoryName':
          iterator['parameterValues'] = territory.territoryName;
          break;
        case 'territoryId':
          iterator['parameterValues'] = territory.territoryId.toString();
          break;
        case 'groupTypeCode':
          iterator['parameterValues'] = territory.groupTypeCode;
          break;
        case 'language':
          iterator['parameterValues'] = territory.defaultLanguageCode;
          break;
      }
    }
    this.userStoreService.userState = this.currentUser;
    this.authService.updateUserPreferences().subscribe();
  }

  getRouteUrlTerritory(_territory: {
    territoryId: number;
    territoryName: string;
    groupTypeCode: string;
  }) {
    return this.router.url;
  }

  checkArray(arrayInp: {}[]) {
    return arrayInp.length > 0;
  }

  checkExhibitorLabel(arrayInp: {}[]) {
    return !(arrayInp.length === 1 && this.selectedRole === '[Exhibitor Relations]');
  }

  checkPublicityLabel(arrayInp: {}[]) {
    return !(arrayInp.length === 1 && this.selectedRole === '[Publicity]');
  }
  onTheaterTrailerClick() {
    this.localStorageService.set('currentItem', 'order-in-theatre');
    this.router.navigateByUrl('/user/order-in-theater-trailer');
  }

  onPOSClick() {
    this.localStorageService.set('currentItem', 'order-pos');
    this.router.navigateByUrl('/user/order-pos');
  }

  /**
   * Common method for territory switches in header 
   * @modified for GAHR1218
   * Also handles pending changes popup
   *
   * @param territory territory object
   */
  switchTerritory(
    territory: {
      territoryId: number;
      territoryName: string;
      groupTypeCode: string;
      defaultLanguageCode: string;
    },
    groupType: string
  ) {
    // Checks for pending changes
    let hasPendingChanges = this.sessionStorageService.get('PC');
    if (hasPendingChanges && hasPendingChanges === 'true') {
      // If any pending changes, show popup confirmation
      this.dialog
        .open(GahMatDialogComponent, {
          data: {
            title: this.translate.instant('unsaved-changes-warning'),
            message: this.translate.instant('leaving-metadata-form-warning'),
            cancelText: this.translate.instant('stay-on-page-warning'),
            okayText: this.translate.instant('leave-without-saving-warning'),
          },
          disableClose: true,
          panelClass: 'gah-mat-dialog__panel',
          backdropClass: 'gah-mat-dialog__backdrop',
          hasBackdrop: true,
        })
        .afterClosed()
        .subscribe((result) => {
          if (result === true) {
            this.process(groupType, territory);
            this.sessionStorageService.remove('PC');
          }
        });
    } else {
      // If no pending changes, go ahead without showing popup confirmation.
      this.process(groupType, territory);
    }
  }

  /**
    * @function Process Switch group and territory (GAHR1218)
    *  @param groupType
    * @param territory
    */
  process(groupType: string, territory: {
    territoryId: number;
    territoryName: string;
    groupTypeCode: string;
    defaultLanguageCode: string;
  }) {
    if (groupType === 'E') {
      this.processSwitchTerritory(territory, 'E');
    } else if (groupType === 'P') {
      this.processSwitchTerritory(territory, 'P');
    }
    else if (groupType === 'VR') {
      this.processSwitchTerritory(territory, 'VR');
    }
  }

  /**
   * @function Switch group and territory
   * @modified for GAHR-1218
   * @param groupType
   * @param territory
   */
  processSwitchTerritory(
    territory: {
      territoryId: number;
      territoryName: string;
      groupTypeCode: string;
      defaultLanguageCode: string;
    },
    groupType: string
  ) {
    this.currentUser.selectedTerritory = territory;
    this.dynamicBreadcrumbService.updateBreadcrumbLabels({ territoryName: territory.territoryName });
    this.currentUser.selectedTerritory.groupTypeCode = groupType;
    this.currentUser.groupTypeCode = groupType;
    this.translate.use(territory.defaultLanguageCode);
    for (let u of this.userRoles) {
      if (territory.groupTypeCode === u.roles['groupTypeCode']) {
        this.requestRoleCode = u.roles['requestRoleCode'];
        this.currentUser.groupRolesId = u.roles['groupRolesId'];
      }
    }

    this.authService.getRequestRole(territory.groupTypeCode, territory.territoryId).pipe(first()).subscribe(
      (data) => {
        for (const iterator of this.currentUser['userPreferences']['userPreferenceDetails']) {
          switch (iterator['parameterName']) {
            case 'territoryName':
              iterator['parameterValues'] = territory.territoryName;
              break;
            case 'territoryId':
              iterator['parameterValues'] = territory.territoryId.toString();
              break;
            case 'groupTypeCode':
              iterator['parameterValues'] = territory.groupTypeCode;
              break;
            case 'requestRoleCode':
              iterator['parameterValues'] = data.requestRoleCode;
              this.requestRoleCode = data.requestRoleCode;
              break;
            case 'groupRoleId':
              iterator['parameterValues'] = data.groupRoleId;
              this.currentUser.groupRolesId = data.groupRoleId;
              break;
            case 'language':
              iterator['parameterValues'] = territory.defaultLanguageCode;
              break;
          }
        }
        this.selectedRole =
          groupType == 'E'
            ? '[Exhibitor Relations]'
            : groupType == 'P'
              ? '[Publicity]'
              : groupType == 'VR'
                ? '[Virtual Reality]'
                : null;

        this.selectedTerritory = this.currentUser?.selectedTerritory['territoryName'];
        this.selectedUserGroupTerritory = this.selectedRole + ' ' + this.selectedTerritory;
        this.currentUser.defaultDateFormat = data.dateformat == 'DF1' ? 'MM/DD/YYYY'
          : 'DD/MM/YYYY';;

        for (let ugt of this.usersGroupsTerritories) {
          if (
            ugt.groupTypeCode === territory.groupTypeCode &&
            ugt.territory.territoryId === territory.territoryId
          ) {
            this.userStoreService.userState.groupsTerritoryId = ugt.groupsTerritoryId;
            break;
          }
        }
        let checkLoc: boolean = false;
        let key = territory.groupTypeCode + this.requestRoleCode;
        this.userStoreService.userState = this.currentUser;
        this.fetchReleaseSchedule();
        this.authService.updateUserPreferences().subscribe(
          (res) => {
            if (
              'order-in-theatre' === this.localStorageService.get('currentItem') ||
              'order-pos' === this.localStorageService.get('currentItem') ||
              this.router.url === '/user/cart-checkout' ||
              this.router.url.includes('/assets/') ||
              this.router.url === '/'
            ) {
              this.localStorageService.remove('currentItem');
              this.router.navigateByUrl('/').then(() => {
                location.reload();
              });
            } else {
              for (let x of this.userMenuMap[key]) {
                if (x.id == this.localStorageService.get('currentMenuItem')['id']) {
                  checkLoc = true;
                  break;
                }
              }
              this.authService.fetchUpdatedUserMenuMap().subscribe();
              this.authService.fetchRolePrivileges().subscribe();
              if (checkLoc) {
                let currentUrl = this.getRouteUrl(this.localStorageService.get('currentMenuItem'));
                if (
                  'group_sales' === this.localStorageService.get('currentMenuItem')['id'] ||
                  'group_sales_req' === this.localStorageService.get('currentMenuItem')['id'] ||
                  'screening' === this.localStorageService.get('currentMenuItem')['id'] ||
                  'order-in-theatre' === this.localStorageService.get('currentItem') ||
                  'order-pos' === this.localStorageService.get('currentItem') ||
                  this.router.url === '/user/cart-checkout' ||
                  this.router.url.includes('/assets/') ||
                  this.router.url === '/'
                ) {
                  this.router.navigateByUrl('/').then(() => {
                    location.reload();
                  });
                } else {
                  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                    this.router.navigate([currentUrl]);
                  });
                }
              } else {
                let homeMenuItem = null;
                for (let element of this.menuItems) {
                  if (element.id === 'home') {
                    homeMenuItem = element;
                    break;
                  }
                }
                this.localStorageService.set('currentMenuItem', homeMenuItem);
                this.router.navigateByUrl('/').then(() => {
                  location.reload();
                });
                if (
                  (this.currentMenuItem === this.localStorageService.get('currentMenuItem') &&
                    'group_sales' === this.localStorageService.get('currentMenuItem')['id']) ||
                  'group_sales_req' === this.localStorageService.get('currentMenuItem')['id'] ||
                  'screening' === this.localStorageService.get('currentMenuItem')['id'] ||
                  this.router.url.includes('/assets/') ||
                  this.router.url === '/user/cart-checkout'
                ) {
                  this.router.navigateByUrl('/').then(() => {
                    this.localStorageService.set('currentMenuItem', homeMenuItem);
                    location.reload();
                  });
                }
              }
            }
          },
          () => {
            let homeMenuItem = null;
            for (let element of this.menuItems) {
              if (element.id === 'home') {
                homeMenuItem = element;
                break;
              }
            }
            this.router.navigateByUrl('/').then(() => {
              this.localStorageService.set('currentMenuItem', homeMenuItem);
              location.reload();
            });
          }
        );
      },
      (err) => {

      }
    );
  }

  changeLanguage(localeCode: string) {
    const index = appLanguages.findIndex((language) => language.localeCode === localeCode);
    const deletedLanguage = appLanguages.splice(index, 1);
    appLanguages.unshift(deletedLanguage[0]);
    if (
      this.translate.currentLang !== localeCode &&
      this.usersPreferredLanguage !== null &&
      this.usersPreferredLanguage !== undefined &&
      this.usersPreferredLanguage !== localeCode &&
      this.currentUser.isAuthenticated &&
      this.currentUser.isLegalAccepted
    )
      this.updateLanguagePreference(localeCode);
    this.translate.use(localeCode);
  }

  updateLanguagePreference(localeCode: string) {
    this.userStoreService?.userState?.userPreferences?.userPreferenceDetails?.map((i) => {
      if (i.parameterName === 'language') {
        i.parameterValues = localeCode;
        this.authService.updateUserPreferences().subscribe();
      }
    });
  }

  /**
   * Function - Fetch Release Schedule
   */
  fetchReleaseSchedule() {
    if (
      this.currentUser != null &&
      this.currentUser.groupsTerritoryId != null &&
      this.currentUser.username != null
    ) {
      this.homepageService
        .fetchUserGuide(this.currentUser.groupsTerritoryId, this.currentUser.username, 'RS')
        .subscribe(
          (res) => {
            if (res != null && res.fileKey != null) {
              this.isReleaseScheduleAvailable = true;
            } else {
              this.isReleaseScheduleAvailable = false;
            }
            this.cdr.detectChanges();
          },
          (err) => { }
        );
    }
  }

  openReleaseSchedule() {
    this.manageHomePageService
      .getUserGuideFile(this.currentUser?.groupsTerritoryId, 'RS')
      .subscribe((res) => {
        const fileURL = URL.createObjectURL(res);
        window.open(fileURL, '_blank');
      });
  }

  //GAHR1218
  checkVrLabel(arrayInp: {}[]) {
    return !(arrayInp.length === 1 && this.selectedRole === '[Virtual Reality]');
  }

  ngOnDestroy() {
    if (this.userStoreSub) {
      this.userStoreSub.unsubscribe();
    }

    if (this.getMenuItemsSub) {
      this.getMenuItemsSub.unsubscribe();
    }

    if (this.menuItemsSub) {
      this.menuItemsSub.unsubscribe();
    }

    if (this.usersGroupsTerritoriesSub) {
      this.usersGroupsTerritoriesSub.unsubscribe();
    }

    if (this.cartItemsSub) {
      this.cartItemsSub.unsubscribe();
    }

    if (this.removedCartItemsSub) {
      this.removedCartItemsSub.unsubscribe();
    }

    if (this.releaseScheduleSub) {
      this.releaseScheduleSub.unsubscribe();
    }
  }
}